import type { Lang } from "./translations";

/**
 * Small helper to localise inline strings that live inside components.
 * Usage: pick(lang, { fr: "Tout", en: "All", es: "Todo" })
 * Falls back to English, then French, when a translation is missing.
 */
export function pick(
  lang: Lang,
  values: { fr: string; en: string; es?: string }
): string {
  if (lang === "en") return values.en;
  if (lang === "es") return values.es ?? values.en;
  return values.fr;
}
